export const isValidEnumValue = (
  object: { [key: string]: string },
  value: string
) => Object.values(object).includes(value);
